import { createFileRoute } from "@tanstack/react-router";
import Mentoria from "@/pages/Mentoria";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/mentoring")({
  head: () => pageHead("mentoring", "en", { links: false }),
  component: Mentoria,
});
